import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export enum FR_INVITE_STATUS {
    AVAILABLE = 'AVAILABLE',
    INVITED = 'INVITED',
    OWNS_THE_GAME = 'OWNS_THE_GAME',
}

export const FR_INVITE_STATUS_TO_TEXT_MAP = {
    [FR_INVITE_STATUS.INVITED]: 'friend-list__status-invited',
    [FR_INVITE_STATUS.OWNS_THE_GAME]: 'friend-list__status-purchased',
    [FR_INVITE_STATUS.AVAILABLE]: 'friend-list__status-available',
};

export const FR_INVITE_STATUS_TO_LIST_ORDER = {
    [FR_INVITE_STATUS.AVAILABLE]: 0,
    [FR_INVITE_STATUS.INVITED]: 1,
    [FR_INVITE_STATUS.OWNS_THE_GAME]: 2,
};

export const INITIAL_FRIENDS: number = 3;

export const FR_FRIEND_LIST_TEXT_KEYS = {
    INVITE_FRIENDS: 'friend-list__invite-friends',
    LOADING: 'friend-list__loading',
    SELECT_ALL: 'friend-list__select-all',
    SHOW_MORE: 'friend-list__show-more',
    NO_FRIENDS_TITLE: 'friend-list__no-friends-title',
    NO_FRIENDS_SUGGESTION: 'friend-list__no-friends-suggestion',
    FEEDBACK_SUCCESS_TITLE: 'friend-list__feedback-success-title',
    FEEDBACK_ERROR_TITLE: 'friend-list__feedback-error-title',
    FEEDBACK_SUCCESS_CONTENT: 'friend-list__feedback-success-content',
    FEEDBACK_ERROR_CONTENT: 'friend-list__feedback-error-content',
    CLOSE: 'friend-list__feedback-close',
    NOT_ELEGIBLE: 'friend-list__not-elegible',
};

export const INVITE_SELECTED_FRIENDS_ANALYTICS = {
    category: CATEGORY.INTERACTION,
    action: 'invite friends'
};

export const CLOSE_INVITE_FRIENDS_ANALYTICS = {
    category: CATEGORY.INTERACTION,
    action: 'close friends invite window'
};
